import { render } from "./QAMolecule.vue?vue&type=template&id=685ec8fb&scoped=true"
import script from "./QAMolecule.vue?vue&type=script&lang=js"
export * from "./QAMolecule.vue?vue&type=script&lang=js"

import "./QAMolecule.vue?vue&type=style&index=0&id=685ec8fb&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685ec8fb"]])

export default __exports__